<div style="text-align: center;max-width: 500px;">
    <mat-card-title style="color: #1A47D6; margin-bottom: 50px; margin-top: 30px;">{{data.heading}}</mat-card-title>
    <p *ngIf="data.case==1">Please ensure you update your mail server setup. For instructions on how to do this please see the <a style="cursor: pointer;" (click)="nav('setup')">Server Setup</a> tab.</p>
    <p *ngIf="data.case==2">Please ensure you remove StayPrivate from your mail server. For instructions on how to do this please see the <a style="cursor: pointer;" (click)="nav('remove-setup')">Remove Setup</a> tab.</p>
    <div>
        <button *ngIf="data.case==1" mat-flat-button color="primary" style="background-color: #1A47D6; margin:20px auto 20px auto;width: 25%;" (click)="nav('setup')">
            Server Setup
        </button>
        <button *ngIf="data.case==2" mat-flat-button color="primary" style="background-color: #1A47D6; margin:20px auto 20px auto;width: 25%;" (click)="nav('remove-setup')">
            Remove Setup
        </button>
    </div>

</div>